import React, { Component } from 'react';
import $ from '../../../common/AjaxRequest';
import { Modal, message, DatePicker, InputNumber } from 'antd';
import API_URL from '../../../common/url';
import moment from 'moment';

const monthFormat = 'YYYY-MM';
const dateFormat = 'YYYY-MM-DD';
const { MonthPicker } = DatePicker;

class SelectOption extends Component {
    state = {
        isEdit: false,
        visible: false,
        confirmLoading: false,
        params: {},
    }

    show = (record) => {
        const { type } = this.props;
        let params;
        if (type == 'WEEK') {
            params = {
                beginDate: moment().startOf('week').format(dateFormat),
                endDate: moment().endOf('week').format(dateFormat),
                ...record,
            };
        } else {
            params = {
                monthDate: moment().format(monthFormat),
                ...record,
            };
        }
        this.setState({
            params,
            visible: true,
            isEdit: !!record,
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    handleCheck = () => {
        const { type, competingCompanyManifestationId } = this.props;
        const { isEdit, params, params: { beginDate, endDate, monthDate, filterOutNumber, groupNumber  } } = this.state;
        if ((type == 'WEEK' && (!beginDate || !endDate)) || (type == 'MONTH' && !monthDate)) {
            if (!beginDate || !endDate) {
                message.warning('请选择时间');
                return;
            }
        }
        if (!filterOutNumber && filterOutNumber !== 0) {
            message.warning(`请输入本${type == 'WEEK' ? '周' : '月'}筛选数量`);
            return;
        }
        if (!groupNumber && groupNumber !== 0) {
            message.warning(`请输入本${type == 'WEEK' ? '周' : '月'}入组数量`);
            return;
        }
        this.setState({ confirmLoading: true });
        if (!isEdit) {
            const { invId } = sessionStorage;
            const options = {
                method: 'POST',
                url: API_URL.competeCompany.checkAddCompetingCompanyGroup,
                data: {
                    ...params,
                    investigationId: invId,
                    competingCompanyManifestationId,
                },
                dataType: 'json',
                doneResult: res => {
                    if (res.competingCompanyGroupId) {
                        Modal.confirm({
                            iconType: 'exclamation-circle',
                            title: `该${type == 'WEEK' ? '周' : '月'}已存在入组情况，是否覆盖？`,
                            onOk: () => {
                                this.submit(res);
                            },
                            onCancel: () => {
                                this.setState({ confirmLoading: false });
                            }
                        })
                    } else {
                        this.submit();
                    }
                },
                errorResult: () => {
                    this.setState({ confirmLoading: false });
                }
            };
            $.sendRequest(options);
        } else {
            this.submit();
        }
    }

    submit = (res = {}) => {
        const { competingCompanyManifestationId } = this.props;
        const { isEdit, params } = this.state;
        let url;
        if (isEdit || Object.keys(res).length) {
            url = API_URL.competeCompany.updateCompetingCompanyGroup;
        } else {
            url = API_URL.competeCompany.submitCompetingCompanyGroup;
        }
        const options = {
            method: 'POST',
            url,
            data: {
                ...res,
                ...params,
                competingCompanyManifestationId,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({
                    visible: false,
                    confirmLoading: false,
                }, () => {
                    this.props.loadData();
                });
            },
            errorResult: () => {
                this.setState({ confirmLoading: false });
            }
        };
        $.sendRequest(options);
    }

    handleInputChange = (value, field) => {
        const { params } = this.state;
        params[field] = value;
        this.setState({ params });
    }

    onBeginChange = (date, dateString) => {
        const { params } = this.state;
        if (date == null){
            params.beginDate = null;
            params.endDate = null;
            this.setState({ params });
            return;
        }
        let dTemp = moment(dateString),
            dTemp1 = moment(dateString);
            params.beginDate = dTemp.startOf('week').format(dateFormat);
            params.endDate = dTemp1.endOf('week').format(dateFormat);
        this.setState({ params });
    }

    onMonthChange = (date, dateString) => {
        const { params } = this.state;
        params.monthDate = dateString;
        this.setState({ params });
    }

    render() {
        const { type } = this.props;
        const { isEdit, visible, confirmLoading, params: { beginDate, endDate, monthDate, filterOutNumber = '', groupNumber = '' } } = this.state;
        const newBeginDate = beginDate ? moment(beginDate) : null;
        const newEndDate = endDate ? moment(endDate) : null;
        const newMonthDate = monthDate ? moment(monthDate) : null;
        const isRequire = <span style={{color: 'red'}}>*</span>;
        return (
            <Modal
                title={`${isEdit ? '修改' : '添加'}入组情况`}
                visible={visible}
                onCancel={this.hide}
                onOk={this.handleCheck}
                className="preview-modal"
                wrapClassName="vertical-center-modal"
                width="440px"
                confirmLoading={confirmLoading}
            >
                <div className="modal-content">
                    <ul className="modal-list">
                        <li className="modal-item" style={{paddingBottom: 20}}>
                            <div className="item-left" style={{width: 120, paddingRight: 10}}>{isRequire}时间:</div>
                            {
                                type == 'WEEK'
                                ?
                                    isEdit
                                    ?
                                        <div className="item-right month-range-picker" style={{width: 182}}>
                                            {beginDate.slice(0, 10)} ~ {endDate.slice(0, 10)}
                                        </div>
                                    :
                                        <div className="item-right month-range-picker" style={{width: 182}}>
                                            <DatePicker
                                                className="begin"
                                                format={dateFormat}
                                                value={newBeginDate}
                                                allowClear={true}
                                                placeholder="开始日期"
                                                onChange={this.onBeginChange}
                                            />
                                            <DatePicker
                                                className="end"
                                                format={dateFormat}
                                                value={newEndDate}
                                                allowClear={true}
                                                placeholder="结束日期"
                                                onChange={this.onBeginChange}
                                            />
                                        </div>
                                :
                                    isEdit
                                    ?
                                        <div className="item-right" style={{width: 182}}>
                                            {monthDate.slice(0, 7)}
                                        </div>
                                    :
                                        <MonthPicker
                                            format={monthFormat}
                                            value={newMonthDate}
                                            allowClear={true}
                                            placeholder="结束日期"
                                            onChange={this.onMonthChange}
                                        />
                            }
                        </li>
                        <li className="modal-item" style={{paddingBottom: 20}}>
                            <div className="item-left" style={{width: 120, paddingRight: 10}}>{isRequire}{type === 'WEEK' ? '本周' : '本月'}筛选数量:</div>
                            <div className="item-right" style={{width: 182}}>
                                <InputNumber precision={0} style={{width: '100%'}} min={-999999999} max={999999999} placeholder='请输入' value={filterOutNumber} onChange={value => this.handleInputChange(value, 'filterOutNumber')}/>
                            </div>
                        </li>
                        <li className="modal-item" style={{paddingBottom: 20}}>
                            <div className="item-left" style={{width: 120, paddingRight: 10}}>{isRequire}{type === 'WEEK' ? '本周' : '本月'}入组数量:</div>
                            <div className="item-right" style={{width: 182}}>
                                <InputNumber precision={0} style={{width: '100%'}} min={-999999999} max={999999999} placeholder='请输入' value={groupNumber} onChange={value => this.handleInputChange(value, 'groupNumber')}/>
                            </div>
                        </li>
                    </ul>
                </div>
            </Modal>
        );
    }
}

export default SelectOption;


// WEBPACK FOOTER //
// ./src/components/competeCompany/Enrollment/UpdateEnrollment.js